/*global gtag*/
import React from 'react';

import Container from 'react-bootstrap/Container'
import Spinner from 'react-bootstrap/Spinner'
import ExpiredURL from './ExpiredURL.js'
import Wait from './Wait.js'


class PaymentSucess extends React.Component {
  constructor(props) {
    super(props);

    // Extract URL parameters
    const urlParams = new URLSearchParams(this.props.location.search);

    // Gumroad parameters
    const sale_id = urlParams.get('sale_id');
    const sale_timestamp = urlParams.get('sale_timestamp');
    const product_id = urlParams.get('product_id');
    const product_name = urlParams.get('product_name');
    const permalink = urlParams.get('permalink');
    const seller_id = urlParams.get('seller_id');
    const email = urlParams.get('email');
    const price = urlParams.get('price');

    // Legacy parameters (for old URLs)
    const url = urlParams.get('url');
    const product = urlParams.get('product');

    // Determine product type from product_id or product parameter
    let productType = product;
    if (product_id === 'wyBbL') {
      productType = 'book';
    } else if (product_id === 'ZcUPU') {
      productType = 'book-plus';
    }

    this.state = {
      status: sale_id ? 200 : (url ? null : 200), // If we have sale_id from Gumroad, it's valid
      url: url,
      product: productType,
      sale_id: sale_id,
      price: price,
      conversionTracked: false,
      fromGumroad: !!sale_id
    }

    // Only check URL validity if we have a legacy url parameter
    if (url && !sale_id) {
      const urlIsValid = this.checkURLValidity(this.state.url);
    } else if (sale_id) {
      // Track immediately if from Gumroad redirect
      this.trackConversion();
    }
  }
  async checkURLValidity(url) {
    const response = await fetch(url, { method: 'GET' }).then(response => {
        this.setState({status: response.status}, () => {
          // Track conversion once URL is validated
          if (response.status === 200 && !this.state.conversionTracked) {
            this.trackConversion();
          }
        });
    }).catch(function(err) {
      console.log('err', err);
    });
  }

  trackConversion() {
    const { product, sale_id, price } = this.state;

    if (
      document.location.hostname.search(
        "www.essentialmathfordatascience.com"
      ) !== -1
    ) {
      // Track purchase event for GA4
      gtag("event", "purchase", {
        transaction_id: sale_id || "unknown",
        value: parseFloat(price) || (product === "book" ? 25 : 35),
        currency: "EUR",
        items: [{
          item_id: product || "book",
          item_name: product === "book" ? "Essential Math for Data Science - Book" : "Essential Math for Data Science - Complete Code",
          price: parseFloat(price) || (product === "book" ? 25 : 35),
          quantity: 1
        }]
      });

      this.setState({ conversionTracked: true });
    }
  }

  render() {
    const { status, fromGumroad, url } = this.state;

    if (status === null) {
      return (
        <Wait />
        );
    }
    else if (status === 403) {
      return (
        <ExpiredURL />
      )
    } else if (status === 200) {
      return (
        <Container>
          <div className="payment-success">
            <h2>Thank you for your purchase!</h2>
            {fromGumroad ? (
              <p>Your order has been confirmed. Check your email for download instructions and access to the private GitHub repository.</p>
            ) : url ? (
              <p>You can download Essential Math for Data Science <a href={url}>here</a></p>
            ) : (
              <p>Check your email for download instructions.</p>
            )}
          </div>
        </Container>
      );
    }

  }
}



export default PaymentSucess;
